import Vue from 'vue'
import methods from './methods.js'

Vue.mixin({
  methods
})
